import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { makeStyles } from "@mui/styles";
import { bindHover, bindMenu, bindPopover, usePopupState } from "material-ui-popup-state/hooks";
import React from "react";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            display: "flex",
        },
        paper: {
            marginRight: theme.spacing(2),
        },
        menuPaper: {
            backgroundColor: `${theme.palette.primary.main} !important`,
        },
    };
});

export default function MenuLink({ menu, menus, onRenderItem }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const popupState = usePopupState({ variant: "popover", popupId: "submenu" });

    function handleListKeyDown(event) {
        if (event.key === "Tab") {
            event.preventDefault();
            setOpen(false);
        }
    }

    const trigger = React.cloneElement(menu, {
        ...bindHover(popupState),
        ref: anchorRef,
    });
    return (
        <React.Fragment>
            {trigger}
            <Popper
                anchorEl={anchorRef.current}
                placement={"bottom-start"}
                role={undefined}
                transition
                disablePortal
                {...bindPopover(popupState)}
            >
                {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: placement === "bottom-start" }}>
                        <Paper className={classes.menuPaper}>
                            <MenuList
                                {...bindMenu(popupState)}
                                autoFocusItem={open}
                                style={{ marginTop: -2, paddingTop: 2, paddingBottom: 2 }}
                                onKeyDown={handleListKeyDown}
                            >
                                {menus.map((menu, index) => (
                                    <MenuItem key={index} onClick={popupState.close}>
                                        {onRenderItem(menu)}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </React.Fragment>
    );
}
